import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { CredibilitySection } from "./components/CredibilitySection";
import { AICapabilitiesSection } from "./components/AICapabilitiesSection";
import { ProjectsSection } from "./components/ProjectsSection";
import { FAQSection } from "./components/FAQSection";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { Toaster } from "./components/ui/sonner";
import InnAqua2025 from "./components/InnAqua2025";
import AquaSur2025 from "./components/AquaSur2025";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { TermsOfService } from "./components/TermsOfService";
import { HomeSEO } from "./components/SEO";

const Home = () => {
  return (
    <div className="min-h-screen">
      <HomeSEO />
      <Header />
      <main>
        <Hero />
        <Services />
        <CredibilitySection />
        <AICapabilitiesSection />
        <ProjectsSection />
        <Contact />
        <FAQSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <DataProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/innaqua" element={<InnAqua2025 />} />
            <Route path="/aquasur" element={<AquaSur2025 />} />
            <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
            <Route path="/terminos-servicio" element={<TermsOfService />} />
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </div>
  );
}

export default App;